import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import "./App.css";

const TravelForm = () => {
  const form = useRef();

  const SERVICE_ID = "service_qvasb8e";
  const TEMPLATE_ID = "template_1stxnwk";
  const USER_ID = "VEr6k6ZYDcWoBJgrh";

  const [residenceCountry, setResidenceCountry] = useState("");
  const [travelCountry, setTravelCountry] = useState("");

  const handleResidenceCountryChange = (e) => {
    setResidenceCountry(e.target.value);
  };

  const handleTravelCountryChange = (e) => {
    setTravelCountry(e.target.value);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure?",
            text: "Do you want to send this message?",
            icon: "question",
            background: "#6F4E37", // Black background
            color: "#fff", // White text
            showCancelButton: true,
            confirmButtonColor: "#988558", // Green confirm button
            cancelButtonColor: "#C2B280", // Red cancel button
            confirmButtonText: "Yes, send it!",
            cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        emailjs
          .sendForm(SERVICE_ID, TEMPLATE_ID, form.current, USER_ID)
          .then((result) => {
            console.log("SUCCESS:", result.text);
            Swal.fire({
              title: "Success!",
              text: "Your travel request has been submitted.",
              icon: "success",
              background: "#988558",
              color: "#fff",
              confirmButtonColor: "#6F4E37",
            });
            form.current.reset();
            setResidenceCountry("");
            setTravelCountry("");
          })
          .catch((error) => {
            console.error("FAILED...", error);
            Swal.fire({
              title: "Error",
              text: "Failed to send. Please try again.",
              icon: "error",
              background: "#988558",
              color: "#fff",
              confirmButtonColor: "#6F4E37",
            });
          });
      }
    });
  };

  return (
    <div className="travel-form-container">
      <div className="row row-two">
        <div className="col info-col">
          <h3>SEND US YOUR REQUIREMENT</h3>
          <p>
            Please fill out this form so we can understand your travel requirements. Based on your preferences, we'll create a personalized itinerary and send it to the email address you provide.
            <br />Your trust means the world to us, and we’re committed to making your journey exceptional.
          </p>
        </div>

        <div className="col form-col">
          <h3 className="trip-heading">Plan Your Trip</h3>
          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <label>
              Name: <input type="text" name="name" required />
            </label>
            <label>
              Email: <input type="email" name="email" required />
            </label>
            <label>
              Contact Number (country code): <input type="text" name="number" required />
            </label>

            <label className="country-label">
              Your Country:
              <select
                className="country-select"
                name="residenceCountry"
                value={residenceCountry}
                onChange={handleResidenceCountryChange}
                required
              >
                <option value="">Select a country</option>
                <option value="China">China</option>
                <option value="Australia">Australia</option>
                <option value="Taiwan">Taiwan</option>
                <option value="USA">USA</option>
                <option value="Europe">Europe</option>
                <option value="Other">Other</option>
              </select>
            </label>


            <label>
              Number of People: <input type="number" name="pack" required />
            </label>

            <label>
              Number of Days: <input type="number" name="days" required />
            </label>

            <label>
              Travel Month: <input type="month" name="month" required />
            </label>

            <label>
              Number of Kids (Below 12 Years): <input type="number" name="kids" />
            </label>

            <label className="country-label">
              Travel Country:
              <select
                className="country-select"
                name="travelCountry"
                value={travelCountry}
                onChange={handleTravelCountryChange}
                required
              >
                <option value="">Select a country</option>
                <option value="Sri Lanka">Sri Lanka</option>
                <option value="China">China</option>
              </select>
            </label>

            <label className="full-width">
              Special Notes (About Tour Preference Place and Others):
              <textarea name="note" rows="3"></textarea>
            </label>

            <button type="submit" className="full-width">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TravelForm;
